var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 24"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".microphone_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16a4 4 0 0 0 4-4V4a4 4 0 0 0-8 0v8a4 4 0 0 0 4 4M6 4a2 2 0 0 1 4 0v8a2 2 0 0 1-4 0Z",
    className: "microphone_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9a1 1 0 0 0-1 1v2a6 6 0 0 1-12 0v-2a1 1 0 0 0-2 0v2a8 8 0 0 0 7 7.93V22H4a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2H9v-2.07A8 8 0 0 0 16 12v-2a1 1 0 0 0-1-1",
    className: "microphone_svg__cls-1"
  })))));
};
export default SvgMicrophone;